import React from 'react';
import { Route } from 'react-router-dom';
import { ContainerWrapper } from '../../components';
import PostCreate from './PostCreate/PostCreate';
import PostsList from './PostList/PostsList';
import PostDelete from './PostDelete/PostDelete';
import PostEdit from './PostEdit/PostEdit';

const Posts = ({ match }) => {
    return (
        <div className="Posts">
            <ContainerWrapper container="posts">
                <Route exact path={ `${ match.url }/new` } component={PostCreate} />
                <Route exact path={ match.path } component={PostsList} />
                <Route exact path={ `${ match.url }/Delete/:postId` } component={PostDelete} />
                <Route exact path={ `${ match.url }/edit/:postId` } component={PostEdit} />
            </ContainerWrapper>
        </div>
    );
}

export default Posts;
